// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IL2Y","col":"styles_col__2jxz-"};